import { Typography } from "@mui/material";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

import { ModalAction } from "../WorkspaceJoin";

type WorkspaceInviteConfirmationModalProps = Pick<
  ConfirmationModalProps,
  "loading" | "open" | "onClose" | "onConfirm" | "confirmProps"
>;

interface WorkspaceInviteModalProps
  extends WorkspaceInviteConfirmationModalProps {
  action: ModalAction;
}

const WorkspaceInviteConfirmationModal = ({
  action,
  ...props
}: WorkspaceInviteModalProps) => {
  return (
    <ConfirmationModal {...props} title="Are you sure?">
      <Typography>
        {action === "accept"
          ? "Are you sure you'd like to join this Workspace? You will be removed from your current Workspace."
          : "Decline this workspace invitation? If you change your mind a new invite must be sent."}
      </Typography>
    </ConfirmationModal>
  );
};

export default WorkspaceInviteConfirmationModal;
